module.exports = __webpack_public_path__ + "img/preview.f80347f3.jpg";